var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full lg:flex lg:items-center lg:h-screen pt-5 lg:pt-0"},[_c('div',{staticClass:"flex md:justify-end justify-center w-1/4 lg:w-auto md:pt-8 pt-2"},[(_vm.breakpoints.w < 1000)?_c('logo-icon'):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }